export const openGoogleDirectionMap = (destination: string) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`
}
